import { render } from "./Header.vue?vue&type=template&id=a08247ec&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=a08247ec&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08247ec"]])

export default __exports__